import { render, staticRenderFns } from "./_DistribusiPerprovinsi.vue?vue&type=template&id=1963ec7f&"
import script from "./_DistribusiPerprovinsi.vue?vue&type=script&lang=js&"
export * from "./_DistribusiPerprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports